
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Projekt Gemini',
	'appExit': 'Idi na stranicu dobrodošlice',


	'widgetsListLabel': 'Lista grafičkih elemenata. Izaberite grafički element i pritisnite Enter da ga dodate.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Ažurno',
	'dirty': 'Nije ažurno',
	'conflict': 'Sukob spremanja pogleda',
	'error': 'Problem spremanja pogleda',
	'failure': 'Poslužitelj se ne može kontaktirati',
	'saveFailed': 'Pogled se ne može spremiti',

	'wa_insync': 'Spremljen',
	'wa_conflict': 'Sukob spremanja pogleda',
	'wa_error': 'Pogled se ne može spremiti',
	'wa_failure': 'Poslužitelj se ne može kontaktirati',

	// Menu Labels
	'changeDisplay': 'Promjena prikaza',
	'changeToColumnChart': 'Promijeni u stupčasti grafikon',
	'changeToBubbleChart': 'Promijeni u mjehuričasti grafikon',
	'toggleMoveHandles': 'Prebaci hvatišta za pomicanje',
	'undo': 'Poništi',
	'redo': 'Ponovi',
	'mode': 'Promijeni način',

	'untitled': 'Neimenovano',
	'remove': 'Ukloni',
	'editTitle': 'Uredi naslov',
	'edit': 'Uredi',
	'done': 'Gotovo',

	// Data tray
	'dataTrayHandleOpenLabel': 'Otvori pretinac podataka',
	'dataTrayHandleCloseLabel': 'Zatvori pretinac podataka',

	// Dialogs
	'dlg_loading': 'Učitavanje...',
	'dlg_ok': 'OK',
	'dlg_create': 'Kreiraj',
	'dlg_cancel': 'Opoziv',
	'dlg_close': 'Zatvori',
	'dlg_update': 'Ažuriraj',
	'dlg_renameBoardTitle': 'Preimenuj ovaj objekt',
	'dlg_renameDatasetTitle': 'Preimenuj ovaj skup podataka',
	'dlg_renameSceneTitle': 'Preimenuj ovu scenu',
	'dlg_NameLabel': 'Naziv:',
	'dlg_NewNameLabel': 'Novi naziv:',
	'dlg_DefaultNameWithDataSet': '%{name} pogled',
	'dlg_ShareTitle': 'Dijeli sadržaj',
	'dlg_UnshareTitle': 'Ukloni dijeljenje sadržaja',
	'dlg_ShareUser': 'ID korisnika:',
	'dlg_NewColumnLabel': 'Naziv novog izračuna',

	'dlg_new': 'Novo...',
	'dlg_open': 'Otvori...',
	'dlg_makeACopy': 'Napravi kopiju',
	'dlg_rename': 'Preimenuj...',
	'dlg_moreToCome': 'Dolazi više akcija...',

	'dlg_use': 'Koristi',

	'dlg_RelinkDatasetTitle': 'Zamijeni skup podataka \'%{datasetName}\' s ...',

	'open_error': 'Pojavio se problem kod otvaranja pogleda.',

	// Delete Board
	'del_dialogTitle': 'Potvrda brisanja',
	'del_itemMsg': 'Jeste li sigurni da želite izbrisati \'%{name}\'?',
	'del_itemsMsg': 'Jeste li sigurni da želite izbrisati %{count} stavki?',
	'del_deleteErr': '\'%{name}\' se ne može izbrisati',

	// List Sorting
	'dlg_ascending': 'uzlazno',
	'dlg_descending': 'silazno',
	'dlg_custom': 'prilagođeno',
	'dlg_none': 'ništa',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Traži',

	'searchHint': 'Pretraži sve podatke',
	'clearSearchResult': 'Isprazni rezultate pretraživanja',
	// Shapes and shapes categories
	// Basic shapes
	'shapesBasicShapesCat': 'Osnovno',
	'shapesCircle': 'Krug',
	'shapesHexagon': 'Šesterokut',
	'shapesLine': 'Linija',
	'shapesOctagon': 'Oktagon',
	'shapesPentagon': 'Peterokut',
	'shapesSquare': 'Kvadrat',
	'shapesTriangle': 'Trokut',
	'shapesDiamond': 'Romb',
	'shapesTitle': 'Svojstva oblika',


	// Advanced shapes
	'shapesAdvancedShapesCat': 'Napredno',
	'shapesSquareRounded': 'Zaobljeni kvadrat',
	'shapesStar': 'Zvjezdica',
	'shapesChevron': 'Ševron',
	'shapesBadge_ribbon': 'Značka s vrpcom',
	'shapesBadge': 'Značka',
	'shapesHeart': 'Srce',
	'shapesExclamation': 'Uskličnik',
	'shapesTrendingup': 'Porast',
	'shapesTrendingdown': 'Pad',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Osobe',
	'shapesFemale': 'Ženska osoba',
	'shapesHappyface': 'Sretno lice',
	'shapesMale': 'Muška osoba',
	'shapesMan': 'Muškarac',
	'shapesNeutralface': 'Neutralno lice',
	'shapesSadface': 'Tužno lice',
	'shapesShakehands': 'Rukovanje',
	'shapesThumbsdown': 'Palac dolje',
	'shapesThumbsup': 'Palac gore',
	'shapesWoman': 'Žena',

	// Weather and places
	'shapesPlacesWeatherCat': 'Mjesta i vrijeme',
	'shapesCity': 'Grad',
	'shapesCloud': 'Oblak',
	'shapesEducation': 'Školovanje',
	'shapesGovernment': 'Državna uprava',
	'shapesHalfcloud': 'Pola oblaka',
	'shapesHouse': 'Kuća',
	'shapesMoon': 'Mjesec',
	'shapesRain': 'Kiša',
	'shapesSunny': 'Sunčano',

	//Vehicles
	'shapesVehiclesCat': 'Vozila',
	'shapesAirplane': 'Zrakoplov',
	'shapesCar': 'Automobil',
	'shapesShip': 'Brod',
	'shapesShoppingcart': 'Kolica za kupovinu',
	'shapesTrain': 'Vlak',
	'shapesTruck': 'Kamion',

	//Objects
	'shapesObjectsCat': 'Objekti',
	'shapesBook': 'Knjiga',
	'shapesBriefcase': 'Aktovka',
	'shapesCalendar': 'Kalendar',
	'shapesCheck': 'Kvačica',
	'shapesClock': 'Sat',
	'shapesDesktop': 'Desktop',
	'shapesDocument': 'Dokument',

	'shapesFood': 'Hrana',
	'shapesGear': 'Oprema',
	'shapesHealth': 'Zdravlje',

	'shapesIdea': 'Ideja',
	'shapesMobile': 'Mobilno',
	'shapesMoney_bill': 'Novčanica',
	'shapesMoney_coin': 'Novčić',
	'shapesPiggybank': 'Kasica prasica',
	'shapesStackofpaper': 'Svežanj papira',
	'shapesStickynote1': 'Samoljepiva napomena 1',
	'shapesStickynote2': 'Samoljepiva napomena 1',
	'shapesTarget': 'Cilj',
	'shapesTool': 'Alat',

	'shapesUmbrella': 'Kišobran',

	'shapesBrain': 'Mozak',
	'shapesSkull': 'Lubanja',
	'shapesEye': 'Oko',

	// Arrows shapes
	'shapesArrowsCat': 'Strelice',
	'shapesRightArrow': 'Strelica desno',
	'shapesLeftArrow': 'Strelica lijevo',
	'shapesDoubleArrow': 'Dvostruka strelica',
	'shapesCurvedArrow': 'Zakrivljena strelica',

	// Callouts shapes
	'shapesCalloutsCat': 'Oblačići',
	'shapesRectCallout': 'Oblačić',

	// Images
	'imageWidgetTitle': 'Slikovni grafički element',
	'imageTextLabel': 'Zalijepite URL i pritisnite Enter da ga spremite',
	'imgUrl': 'URL slike',
	'imgPasteLink': 'Zalijepite URL i pritisnite Enter da ga spremite',
	'imgResizeToFit': 'Promijeni veličinu tako da odgovara veličini slike',
	'imgHeight': 'Visina:',
	'imgWidth': 'Širina:',
	'imgTransparency': 'Transparentnost:',
	'imgMissingUrl': 'Nedostaje URL slike',
	'imgUrlValidationError': 'URL slike nije važeći',
	'imgUrlInvalidDomainError': 'URL slike pokazuje na domenu koju nije odobrio vaš administrator. Domene koje je odobrio vaš administrator su "%{domains}"',


	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Pokreni',
	'dataPlayerValueListLabel': 'Vrijednosti playera podataka',
	// Text Widget
	'textWidgetTitle': 'Grafički element teksta',
	'textStyle': 'Stilovi',
	'textStyleDescription': 'Unaprijed formatirani stilovi teksta',
	'textTitleStyle': 'Naslov',
	'textTitleSmallStyle': 'Mali naslov',
	'textSubtitleStyle': 'Podnaslov',
	'textBodyStyle': 'Tijelo',
	'textBodySmallStyle': 'Malo tijelo',
	'textCaptionStyle': 'Zaglavlje',
	'textQuoteStyle': 'Citat',
	'textQuoteSmallStyle': 'Mali citat',
	'textResponsiveStyle': 'Automatska veličina',
	'textAutoFontSize': 'Automatski',
	'textFontFamilySubClassHairline': 'Vrlo tanko',
	'textFontFamilySubClassThin': 'Tanko',
	'textFontFamilySubClassThinItalic': 'Tanko kurziv',
	'textFontFamilySubClassExtraLight': 'Vrlo svjetlo',
	'textFontFamilySubClassExtraLightItalic': 'Vrlo svjetlo kurziv',
	'textFontFamilySubClassLight': 'Svjetlo',
	'textFontFamilySubClassLightItalic': 'Svjetlo kurziv',
	'textFontFamilySubClassRegular': 'Redovni',
	'textFontFamilySubClassRegularItalic': 'Redovni kurziv',
	'textFontFamilySubClassItalic': 'Kurziv',
	'textFontFamilySubClassMedium': 'Srednji',
	'textFontFamilySubClassMediumItalic': 'Srednji kurziv',
	'textFontFamilySubClassHeavy': 'Deblje',
	'textFontFamilySubClassHeavyItalic': 'Deblji kurziv',
	'textFontFamilySubClassDemiBold': 'Polu podebljano',
	'textFontFamilySubClassDemiBoldItalic': 'Polu podebljani kurziv',
	'textFontFamilySubClassBold': 'Podebljano',
	'textFontFamilySubClassBoldItalic': 'Podebljani kurziv',
	'textFontFamilySubClassExtraBold': 'Jako podebljano',
	'textFontFamilySubClassExtraBoldItalic': 'Jako podebljani kurziv',
	'textFontFamilySubClassBlack': 'Crna',
	'textFontFamilySubClassBlackItalic': 'Crni kurziv',
	'textFontFamilySubClassStencil': 'Matrica',
	'responsiveCoachmarkTitle': 'Automatska veličina fonta',
	'responsiveCoachmarkContents': 'Veličina fonta se automatsku podešava kad promijenite veličinu ovog tipa teksta. Veličinu fonta možete postaviti u svojstvima teksta.',

	'propText': 'Detalji teksta',
	'propTextReturn': 'Svojstva teksta',

	'textFontSize': 'Veličina fonta',
	'textFontFamily': 'Obitelj fontova',
	'textFontWeight': 'Debljina fonta',

	// Widget Properties
	'propImageLink': 'Veza slike',
	'propMissingURL': 'Unesite URL',
	'propImgTop': 'Svojstva slike',
	'propGeneralReturn': 'Opća svojstva',
	'propStyle': 'Opće',
	'propStyleReturn': 'Opće',
	'propFillColor': 'Boja za ispunu',
	'propTextColor': 'Boja teksta',
	'propBorderColor': 'Boja obruba',
	'propMaintainAxisScales': 'Zadrži skalu osi',
	'propShowItemLabel': 'Pokaži oznaku stavke',
	'propHideLegend': 'Sakrij legendu',
	'propColorPalette': 'Paleta',
	'propLegendPosition': 'Položaj legende',
	'propHideAxisTitleLabels': 'Sakrij naslove osi',
	'propLineColor': 'Boja linije',
	'propBubbleColor': 'Boja mjehurića',
	'propInterpolation': 'Glatke linije',
	'propElementColor': 'Boja elementa vizualizacije',
	'propSymbolShape': 'Oblik simbola',
	'propHeatScalePalette': 'Redoslijed boja',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Tamnije boje predstavljaju niže vrijednosti.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Tamnije boje predstavljaju više vrijednosti.',
	'propImageDetails': 'Detalji slike',
	'propWebDetails': 'Detalji web stranice',
	'propMediaDetails': 'Detalji medija',
	'propPasteLink': 'Unesite URL i pritisnite Enter',

	//Layout Properties
	'propPositionLabel': 'Položaj',
	'propPositionXAxis': 'X',
	'propPositionYAxis': 'Y',
	'propResizeLabel': 'Veličina',
	'propResizeWidth': 'Širina',
	'propResizeHeight': 'Visina',
	'propRotateLabel': 'Rotiraj',
	'propRotateAngle': 'Kut',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Količina ikona',
	'propScaleDescription': 'Izaberite broj ikona',
	'propScaleFew': 'Nizak',
	'propScaleDefault': 'Default',
	'propScaleMany': 'Visok',

	'mediaAriaLabel': 'unos url-a',
	'ariaGroupLabel': 'Kategorija padajuće liste: %{cateoryLabel} podatak: %{itemLabel}. Pritisnite tipku DOWN da proširite listu. Pritisnite tipke UP i DOWN za kretanje kroz listu ili pritisnite tipku ESCAPE za skupljanje liste.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Zadnje osvježavanje: prije %{timeInterval}',
	'widgetTimer': 'Timer grafičkog elementa',

	// Theme colors
	'transparent': 'Bez boje',
	'white': 'Bijela',
	'lightGrey': 'Svjetlo siva',
	'grey': 'Siva',
	'darkGrey': 'Tamno siva',
	'black': 'Crna',
	'lightBlue': 'Svjetlo plava',
	'blue': 'Plava',
	'darkBlue': 'Tamno plava',
	'yellow': 'Žuta',
	'orange': 'Narančasta',
	'lime': 'Limeta',
	'green': 'Zelena',
	'peach': 'Breskva',
	'red': 'Crvena',
	'violet': 'Ljubičasta',
	'aqua': 'Voda',
	'purple': 'Grimizna',
	'plum': 'Tamno ljubičasta',

	//Theme Palette Label
	'paletteLabel': 'IBM-ova paleta %{number}',
	'heatPaletteLabel': 'IBM-ova paleta toplina %{number}',
	'conditionalPaletteLabel': 'IBM-ova uvjetna paleta %{number}',
	'userPaletteColor_lightTheme': 'IBM-ova svjetla paleta',
	'userPaletteColor_defaultTheme': 'IBM-ova default paleta',
	'userPaletteColor_darkTheme': 'IBM-ova tamna paleta',

	// Dashboard
	'propDashboardBackgroundColor': 'Boja pozadine',
	'dataCache': 'Predmemorija podataka',
	'dataCache_on': 'Uključeno',
	'dataCache_off': 'Bez predmemorije',
	'dataCache_auto': 'Automatski',
	'propLayoutPositioning': 'Pozicioniranje izgleda',
	'propLayoutRelative': 'Relativno',
	'propLayoutAbsolute': 'Apsolutno',
	'propLayoutPositioningCoachmarkTitle': 'Izbor stila izgleda',
	'propLayoutPositioningCoachmarkContent': 'U relativnom izgledu se veličina i položaj grafičkih elemenata podešava tako da stanu na ekran. U apsolutnom izgledu se grafički elementi pojavljuju u veličini i na mjestima gdje ste ih smjestili u pogled bez obzira na veličinu ekrana.',
	'gridText': 'Pokaži mrežu',
	'snapText': 'Poravnaj s mrežom',
	'snapObjectsText': 'Poravnaj s objektima',
	'fitPageText': 'Prilagodi stranicu',
	'gridLabel': 'Mreža',
	'heightUnit': 'v',
	'widthUnit': 'š',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Veličina stranice',
	'propPageSizePresetAriaLabel': 'Veličina stranice unaprijed postavljena',
	'propPageSizePreset': 'Unaprijed postavljeno',
	'propPageSizePresetCustom': 'Prilagođeno',
	'propPageSizePreset16x9': 'Ekran 16:9',
	'propPageSizePreset4x3': 'Ekran 4:3',
	'propPageSizePresetInfographic': 'Infografika',
	'propPageSizeWidth': 'Širina',
	'propPageSizeHeight': 'Visina',
	'propPageSizeWidthAriaLabel': 'Širina veličine stranice',
	'propPageSizeHeightAriaLabel': 'Visina veličine stranice',
	'propPageSizeAdjustedMessage': 'Veličina stranice je povećana jer je vaš unos bio ispod minimuma ili ne bi stao na vašu kontrolnu ploču.',
	'propTabShow': 'Pokaži kartice',
	'propShowTabsInPreview': 'Pokaži kartice u pregledu',
	'multilingualDashboardsLabel': 'Jezici',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Default',
	'multilingualDashboardsAddLinkText': 'Dodaj drugi jezik',
	'multilingualDashboardsSelect': 'Izbor',
	'multilingualDashboardsButtonLabel': 'Dodaj',
	'multilingualDashboardTranslationMode': 'Radite li sad u načinu za prevođenje (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Gotovo',
	'multilingualDashboardRemainingStrings': 'Preostalo je %{numTranslationsLeft} prijevoda',
	'multilingualDashboardRemainingString': 'Preostao je 1 prijevod',
	'multilingualDashboardsSetDefault': 'Postavi defaultni jezik',
	'multilingualDashboardIconMore': 'Više akcija za jezik %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Prevodljivo područje',
	'multilingualDeleteTitle': 'Izbriši jezik',
	'multilingualDeleteLanguageWarning': 'Jeste li sigurni da želite izbrisati  \'%{language}\' jezik?',
	'multilingualSelectLanguage': 'Izaberite jezik',
	'confirmLayoutStyleUpgradeTitle': 'Primijeni na sve kartice',
	'confirmLayoutStyleUpgrade': 'Primijeniti ovaj stil izgleda na sve kartice kontrolne ploče?',

	//Tabs
	'tabDeleteDialogYesButton': 'Da',
	'tabDeleteDialogNoButton': 'Ne',
	'tabDeleteDialogTitle': 'Izbriši ovu karticu?',
	'tabDeleteDialogMessage': 'Sav sadržaj na ovoj kartici će također biti izbrisan.',

	// Vis widget
	'propVisTypeReturn': 'Tipovi vizualizacije',
	'propVisDetails': 'Detalji',

	// Alignment picker
	'propAlignPickTop': 'Poravnaj na vrhu',
	'propAlignPickRight': 'Poravnaj desno',
	'propAlignPickBottom': 'Poravnaj na dnu',
	'propAlignPickLeft': 'Poravnaj lijevo',
	'propAlignPickCenter': 'Poravnaj u sredini',
	'propAlignPicker': 'Poravnanje',

	// Toolbar picker
	'propToolbarPickBold': 'Podebljano',
	'propToolbarPickUnderline': 'Podcrtano',
	'propToolbarPickItalic': 'Kurziv',
	'propToolbarPickJustifyLeft': 'Poravnaj lijevo',
	'propToolbarPickJustifyCenter': 'Poravnaj u sredini',
	'propToolbarPickJustifyRight': 'Poravnaj desno',
	'propToolbarPickJustify': 'Poravnaj',

	'propList': 'Lista',
	'propOrderedList': 'Poredana lista',
	'propUnorderedList': 'Neporedana lista',

	// Symbol shapes
	'propCircle': 'Krug',
	'propTriangle': 'Trokut',
	'propSquare': 'Kvadrat',
	'propRect': 'Pravokutnik',
	'propStar': 'Zvjezdica',
	'propCross': 'Križ',
	'propPlus': 'Plus',
	'propPoly': 'Poligon',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'Lijevo',
	'propRight': 'Desno',
	'propTop': 'Vrh',
	'propBottom': 'Dno',

	// Interpolation options
	'propSmooth': 'Glatko',
	'propStraight': 'Ravna',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Lista', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Pomakni lijevo', // screen reader
	'srWidgetMoveUp': 'Pomakni gore', // screen reader
	'srWidgetMoveRight': 'Pomakni desno', // screen reader
	'srWidgetMoveDown': 'Pomakni dolje', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Povećaj proporcionalno', // screen reader
	'srWidgetResizeSmaller': 'Smanji proporcionalno', // screen reader
	'srWidgetResizeBiggerV': 'Povećaj okomito', // screen reader
	'srWidgetResizeSmallerV': 'Smanji okomito', // screen reader
	'srWidgetResizeBiggerH': 'Povećaj vodoravno', // screen reader
	'srWidgetResizeSmallerH': 'Smanji vodoravno', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Rotiraj u smjeru kazaljke na satu', // screen reader
	'srWidgetRotateCCW': 'Rotiraj suprotno od kazaljke na satu', // screen reader

	// Recommended types
	'visChange': 'Promijeni vizualizaciju',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Vizualizacija',
	'chartLabel': '%{chartName} grafikon',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pritisnite F12 za navigaciju unutar grafičkog elementa',
	'f10KeyDescription': 'Pritisnite F10 za pokretanje pogleda s grafičkim elementom u fokusu',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} s vrijednosti %{value}',

	'shapeColorLabel': 'Boja oblika',
	'showLegendLabel': 'Pokaži legendu',

	//Webpage
	'webpageWidgetTitle': 'Grafički element web stranice',
	'webpagePasteLink': 'Zalijepite URL i pritisnite Enter da ga spremite',
	'propWebpageLink': 'URL web stranice',
	'propWebpageTitle': 'Naslov web stranice',
	'propWebpageTitleDescription': 'Naslov web stranice',
	'propWebpageTop': 'Svojstva web stranice',
	'webpageMissingUrl': 'Nedostaje URL web stranice',
	'webpageUrlValidationError': 'URL web stranice nije važeći',
	'webpageHttpValidationError': 'Web stranici morate pristupiti koristeći HTTPS vezu da bi je pretražitelj mogao prikazati',
	'webpageInvalidDomainError': 'URL web stranice pokazuje na domenu koju nije odobrio vaš administrator. Domene koje je odobrio vaš administrator su "%{domains}"',

	//VizState
	'vzErrorLoading': 'Ne može se učitati vizualizacija',
	'vzErrorLoadingMissingData': 'Ne može se učitati vizualizacija, nedostaju podaci o kontekstu',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Grafički element medija',
	'mediaPasteLink': 'Zalijepite URL i pritisnite Enter da ga spremite',
	'videoHeight': 'Visina:',
	'videoWidth': 'Širina:',
	'propMediaLink': 'Poveznica medija',
	'propMediaTitle': 'Naslov medija',
	'propMediaTitleDescription': 'Naslov medija',
	'propMediaTop': 'Svojstva medija',
	'mediaMissingUrl': 'Nedostaje URL veze medija',
	'mediaUrlValidationError': 'URL veze medija nije važeći',
	'mediaUnknownValidationError': 'Ovaj tip medija nije podržan',
	'mediaHttpValidationError': 'Datoteci medija morate pristupiti koristeći HTTPS vezu da bi je pretražitelj mogao prikazati',
	'mediaInvalidDomainError': 'URL datoteke pokazuje na domenu koju nije odobrio vaš administrator. approved by your administrator. Domene koje je odobrio vaš administrator su "%{domains}"',

	// Properties pane
	'commonPropertiesLabel': 'Svojstva',

	// Data strip
	'dataSetsLabel': 'Skup podataka',
	'dataViewsLabel': 'Pogled',
	'columnQuality': 'Kvaliteta podataka',
	'columnProperties': 'Svojstva podataka',

	'dataQuality': 'Kvaliteta podataka',
	'dataQualityRowCount': 'Broj redova',
	'dataQualityDistribution': 'Distribucija',
	'dataRowLabel': 'Podaci',

	// Modelling UI
	'typeColumn': 'Tip',
	'modellingColumnType': 'Tip',
	'modellingColumnAggregation': 'Agregacija',
	'modellingColumnUsage': 'Upotreba',
	'modellingColumnSort': 'Sortiraj',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Kategorija',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Učitavanje...',

	'modellingProcessing': 'Obrada...',
	'modellingImport': 'Import',
	'modellingReimport': 'Ponovni import',
	'modellingDatasourceTitle': 'Izvor podataka',
	'modellingImportStartedTitle': 'Importiranje je pokrenuto',
	'modellingImportStartedText': 'Importiranje vaših podataka može potrajati.\n\n(Možete kreirati pogled tijekom importiranja podataka.)',
	'importDatasourceTitle': 'Povezivanja',
	'dropHere': 'Ispustite ovdje za kreiranje novog izvora podataka...',
	'browseButton': 'Pregled',
	'errorNoData': 'Nema podataka za obradu.',
	'errorNoFile': 'Nema datoteke za upload.',
	'errorUploadFailed': 'Upload se ne može izvesti.',
	'uploadSucceessful': 'Uspješan upload',
	'del_datasourceTitle': 'Izbriši skup podataka',
	'del_datasourceMsg': 'Jeste li sigurni da želite izbrisati \'%{name}\'?',
	'modellingFileUpdate': 'Ažuriraj',
	'modellingFileUpdateTitle': 'Ažuriraj skup podataka',
	'modellingFileUpdateDescription': 'Želite li ažurirati \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Ažuriranje \'%{name}\'',
	'modellingUpdateStartedTitle': 'Pokrenut je import ažuriranja',
	'modellingUpdateStartedText': 'Ažuriranje vaših podataka može potrajati.\n\n(Možete kreirati pogled tijekom ažuriranja podataka.)',
	'modellingErrorImportUploadNoFile': 'Nema datoteke za upload.',
	'modellingErrorImportUploadFailed': 'Upload se ne može izvesti.',
	'modellingErrorImportUploadInvalidType': 'Tip datoteke nije važeći.',
	'modellingErrorImportUploadTableFailed': 'Ne mogu se dohvatiti tablice.',
	'modellingIntentResultsTitle': 'Izaberite predloženi skup podataka koji će se koristiti',
	'modellingColumnViewRelationships': 'Pregled povezanih tablica',
	'modellingTableRelatedTables': 'Tablice koje se odnose na \'%{name}\'',
	'modellingTable': '%{name} - tablica',
	'modellingColumnIncludedInDataSet': 'Dodano',
	'modellingDataSet': 'Skup podataka',
	'modellingViewInDataSet': 'Pregled u skupu podataka',
	'modellingViewRelatedTables': 'Pregled povezanih',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Nisu pronađene povezane tablice',

	'modellingValidatingDataset': 'Provjera...',
	'datasetFinishedRefreshing': 'Skup podataka %{datasetName} je osvježen.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Staza spajanja:',
	'modellingJoinColumns': 'Definirajte stazu spajanja za tablicu: %{name}',
	'modellingJoinToTable': 'Spoji s tablicom: %{name}',

	// Data Quality
	'excluded': 'Isključeno',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'Če',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filter',
	'modellingColumnSortNone': 'Poništi sortiranje',
	'modellingColumnSortAsc': 'Sortiraj uzlazno',
	'modellingColumnSortDesc': 'Sortiraj silazno',
	'modellingColumnRemove': 'Ukloni ovaj stupac',

	// Import File Browser
	'dropboxPageTitle': 'Nova Dropbox veza',
	'sizeColumn': 'Veličina',

	//Modelling Column Property Values
	'dataType_string': 'Niz znakova',
	'dataType_date': 'Datum',
	'dataType_integer': 'Cijeli broj',
	'dataType_double': 'Dvostruki',
	'dataType_float': 'Pomični',
	'dataType_boolean': 'Booleov',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Brojač',
	'defaultAggregation_countdistinct': 'Brojač različitih',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Prosjek',
	'defaultAggregation_sum': 'Zbroj',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Činjenica',
	'type_attribute': 'Atribut',

	'defaultSort_none': 'Nemoj sortirati',
	'defaultSort_asc': 'Sortiraj uzlazno',
	'defaultSort_desc': 'Sortiraj silazno',

	'category_none': 'Ništa',
	'category_location': 'Lokacija',
	'category_monetary': 'Monetarno',
	'category_time': 'Vrijeme',

	// Root menu
	'rootMenuTitle': 'Glavni izbornik',

	'errorMessageTitle': 'Greška',
	'errorMessageDetails': 'Detalji: ',
	'errorMessageTitleAssetAlreadyExists': 'Sredstvo već postoji',

	'defaultTabTitle': 'Kartica %{index}',
	'tabAddBtnTitle': 'Dodaj novu karticu',

	'unsupportedConditionalFormattingEncountered': 'Uvjetno formatiranje više se ne primjenjuje na neke stupce.',


	// Homepage View
	'nameColumn': 'Naziv',
	'creatorColumn': 'Kreirao',
	'creationDateColumn': 'Datum kreiranja',
	'versionColumn': 'Verzija',
	'modifiedColumn': 'Zadnja promjena',

	'filterBy': 'Filtriraj stavke',
	'allFilter': 'Sve stavke',
	'createdByMeFilter': 'Koje sam ja kreirao',
	'sharedWithMeFilter': 'Koje se dijele sa mnom',
	'favoritesFilter': 'Moji favoriti',
	'recentsFilter': 'Nedavno dodane',
	'sortBy': 'Sortiraj po',

	// Sort Menu
	'sortModified': 'Promijenjeno',
	'sortUpdated': 'Ažurirano',
	'sortName': 'Naziv',

	'viewAs': 'Pregledaj kao',
	'thumbnailsView': 'Pregledaj kao sličicu',
	'listView': 'Pregledaj kao listu',
	'createMenu': 'Kreiraj',
	'newAppItem': 'Kontrolna ploča',
	'newDataSet': 'Skup podataka',

	'menuSelectionState_a11y': '"%{item}" izbornik je postavljen na "%{selectedItem}"',

	'unableToShareItem': 'Stavka "%{item}" se ne može dijeliti.',
	'toastFetchingContent': 'Dohvaćanje dodatnog sadržaja...',
	'unableToGetData': 'Sadržaj se ne može dohvatiti.',
	'unableToFavorite': 'Ne može se promijeniti status favorita.',
	'hpErrorMissingRequiredOptions': 'Nedostaju obavezne inicijalizacijske opcije',
	'unableToOpenBoard': '"%{name}" se ne može otvoriti.',
	'unableToDuplicateBoard': 'Ne može duplicirati "%{name}".',
	'unableToCreateBoard': '"%{name}" se ne može kreirati.',
	'unableToCreateBoardNameConflict': 'Sredstvo s istim nazivom već postoji.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Redovi',
	'importWarnings': 'Upozorenja',
	'lineNumbers': 'Linije',
	'excerptFromSource': 'Isječak',
	'reason': 'Razlog',
	'numberOfRowsDropped': 'redova ispušteno',
	'oneRowDropped': '1 red je ispušten',

	// Type Menu
	'typeMenuLabel': 'Tip',
	'dashboardsLabel': 'Kontrolne ploče',
	'datasetsLabel': 'Skupovi podataka',
	'storiesLabel': 'Priče',
	'allLabel': 'Svi tipovi',

	// Board Page View App Bar
	'datasets': 'Skupovi podataka',
	'settings': 'Svojstva',
	'add': 'Dodaj',
	'widgets': 'Grafički elementi',
	'dashboardProperties': 'Svojstva kontrolne ploče',
	'pins': 'Zbirka',
	'pinsOld': 'Moji prikvačeni elementi',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} pin |||| %{smart_count} pins',
	'pinSearch': 'Traži',
	'pinSearchOld': 'Traži prikvačene elemente',
	'pinListView': 'Pogled liste',
	'pinIconView': 'Pogled ikona',
	'pinRemove': 'Ukloni',
	'pinCreate': 'Kreiraj',
	'pinDeleteError': 'Ne možemo izbrisati sredstvo ili više sredstava iz zbirke. Pokušajte ponovno kasnije.',
	'pinDeleteErrorOld': 'Ne možemo izbrisati jedan ili više prikvačenih elemenata. Pokušajte ponovno kasnije.',
	'pinRetrieveError': 'Ne možemo dohvatiti jedan ili više prikvačenih elemenata. Pokušajte ponovno kasnije.',
	'NoPinsCollected': 'Nema prikvačenih vizualizacija',
	'pinDeletedToast': 'Prikvačeno je uklonjeno',
	'pinAddedToast': 'Prikvačeno je uspješno dodano u Moje prikvačene elemente',
	'pinningToast': 'Obrada prikvačenog elementa...',
	'pinDateFilter': 'Filter datuma',
	'pinDateFilterAll': 'Sve',
	'pinDateFilterToday': 'Danas',
	'pinDateFilterYesterday': 'Jučer',
	'pinDateFilterPastWeek': 'Prošli tjedan',
	'pinDateFilterPastMonth': 'Prošli mjesec',
	'pinDateFilterEarlier': 'Ranije',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Uredi naslov',
	'toolbarActionSort': 'Sortiraj',
	'toolbarActionSortAscending': 'Sortiraj uzlazno',
	'toolbarActionSortDescending': 'Sortiraj silazno',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Format',
	'toolbarActionFormatAbbreviation': 'Skrati',
	'toolbarActionFormatNone': 'Automatski',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Vrh ili dno',
	'toolbarActionAddShape': 'Dodaj oblik',
	'toolbarActionRmvShape': 'Ukloni oblik',
	'toolbarActionToggleShapeDrop': 'Oblik infografika',
	'toolbarActionToggleShapeDropTitle': 'Kreiranje infografike',
	'toolbarActionToggleShapeDropText': 'Povucite oblik u ovo polje da kreirate infografiku.',
	'toolbarActionAggregationType': 'Sumiraj',
	'toolbarDeleteActionText': 'Ukloni stupac',
	'toolbarActionFilterLocalKeepSelected': 'Zadrži',
	'toolbarActionFilterLocalExcludeSelected': 'Isključi',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Jednostavni izračun',
	'toolbarActionDrillBack': 'Natrag',
	'toolbarActionDrillUp': 'Buši prema gore',
	'toolbarActionDrillDown': 'Buši prema dolje',
	'toolbarActionNavigate': 'Navigacija',
	'toolbarActionCreateFilterGroup': 'Kreiraj novo povezivanje',
	'toolbarActionDisconnectFilterGroup': 'Prekini sve veze',
	'toolbarActionLinkFilterGroup': 'Dodaj postojećoj vezi',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Dodaj',
	'sidebarMultiselect': 'Prebaci višestruki izbor',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} izabrano',

	'multiselectWithTotalMsg': '%{count} od %{total}',
	'sidebarGoBack': 'Idi natrag',

	//DataSet pane
	'errorLoadingDataSets': 'Ne možemo učitati ovaj skup podataka',
	'errorLoadingDataSetMetaData': 'Ne možemo učitati ovaj skup podataka',
	'dataSetPaneLastUpdated': 'Zadnje ažuriranje: %{date}',
	'dataSetPaneDateUnknown': 'Nepoznato',
	'sourcePaneLabel': 'Izabrani izvori',
	'addSourceLabel': 'Dodaj izvor',
	'find_label': 'Traži',
	'navigationPathsLabel': 'Navigacijske staze',

	//widgetlist
	'errorLoadingWidgetList': 'Ne možemo učitati objekte.',
	'errorLoadingThemeFile': 'Ne možemo učitati definiciju teme',
	'errorLoadingLayoutFile': 'Ne možemo učitati pogled.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Ne možemo učitati dostupne definicije vizualizacija',

	'dwErrorLoadingVisualizationNotFound': 'Ne možemo učitati objekt jer mu nedostaje definicija vizualizacije',
	'dwErrorLoadingVisualizationListNotFound': 'Ne možemo učitati vizualizaciju.',
	'dwErrorRunningQuery': 'Ne mogu se dohvatiti podaci iz skupa podataka %{datasetName}.',
	'dwErrorGeoData': 'Pojavljuju se problemi kod prikaza geografskih podataka u mapi. Molim, izaberite drugi tip vizualizacije. ',
	'dwPromptSignonCancelWarning': 'Podaci ove vizualizacije nisu dostupni. Molim, navedite parametre s ispravnim vjerodajnicama.',
	'dwErrorMissingDataset': 'Ne može se učitati vizualizacija jer njezin pridruženi skup podataka \'%{datasetName}\' nije dostupan.',
	'dwErrorRenderingVisualization': 'Ne možemo učitati ovu vizualizaciju.',
	'dwErrorVisualizationTooSmall': 'Vizualizacija je premalena za prikaz podataka koje sadrži. Povećajte vizualizaciju ili ograničite podatke koje sadrži.',
	'aria_label_datatable': 'Tablica podataka',
	'aria_key_navi_datatable_desc': 'Koristite tipke strelica za navigaciju do ćelija. Pritisnite tipke Control i Home za pomak na prvi red, tipke Control i End za pomak na zadnji red.',
	'geomapUnrecognizedLocations': 'Neprepoznate lokacije:',
	'geomapAmbiguousLocations': 'Neodređene regije:',

	// custom widget
	'customWidget': 'Prilagođeni grafički element',
	'noCustomWidgets': 'Nema prilagođenih grafičkih elemenata',

	// Action names
	'toggleContextBar': 'Prebaci traku konteksta',
	'delete': 'Izbriši',
	'share': 'Dijeli',
	'unshare': 'Zaustavi dijeljenje',
	'rename': 'Preimenuj',
	'close': 'Zatvori',
	'duplicate': 'Dupliciraj',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Pokušaj ponovno',

	'changeTemplate': 'Promijeni predložak',

	// Aggregation Types
	'sum': 'Zbroj',
	'count': 'Brojač',
	'countdistinct': 'Brojač različitih',
	'avg': 'Prosjek',
	'min': 'Minimum',
	'max': 'Maksimum',
	'custom': 'Prilagođeno',
	'calculated': 'Izračunato',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% promjene',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Kriteriji za vizualizaciju...',
	'QuickAddResultsHeader': 'Vizualizacije podataka',
	'NoQuickAddResults': 'Nema rezultata za vaš izbor. Želite li kreirati novi skup podataka?',
	'NoQuickAddResultsRetry': 'Ne mogu se pronaći podudaranja. Pokušajte ponovno s drugim pojmovima.',
	'templateWidgetTitle': 'Predložak',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(prazno)',

	'nullValueContent': '(nema vrijednost)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Filter teksta - %{columnName}',

	'textFilterSelectTab': 'Izbor',

	'textFilterConditionTab': 'Postavite uvjet',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Nema dostupnih stavki.',

	'textFilterEquals': 'Jednako',
	'textFilterContains': 'Sadrži',
	'textFilterBeginsWith': 'Počinje s',
	'textFilterEndsWith': 'Završava s',
	'textFilterDoesNotEqual': 'Nije jednako',
	'textFilterDoesNotContain': 'Ne sadrži',
	'textFilterDoesNotBeginWith': 'Ne počinje s',
	'textFilterDoesNotEndWith': 'Ne završava s',
	'textFilterSampleText': 'Na primjer: A',

	'textFilterAndButton': 'I',
	'textFilterOrButton': 'Ili',

	'dateFilterMessage': 'Izaberite raspon datuma',
	'dateRangeControlRegionLabel': 'Filter raspona podataka - %{columnName}',
	'dateFilterRangeOption': 'Opcije raspona',
	'dateFilterDateLabel': 'Datum',
	'dateFilterBlank': '(prazno)',
	'dateFilterBefore': 'Prije',
	'dateFilterAfter': 'Poslije',
	'dateFilterBetween': 'Između',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': 'Datum',
	'dateIncludeBlankLabel': 'Uključi prazan datum',

	'timeTitle': 'Vrijeme',
	'timeFilterMessage': 'Izaberite vremenske raspone',
	'dateTimeFilterMessage': 'Izaberite raspone datuma i vremena',

	'topbottomNumberOfResultsLabel': 'Broj rezultata',
	'topbottomPercentLabel': 'Postotak',
	'topbottomNumberOfResultsLimit': 'Između %{lower}-%{higher}',
	'topbottomSelectOption': 'Opcija vrha ili dna',
	'topbottomOptionLabel': 'Pokaži',
	'searchByLabel': 'Po',
	'searchNoMatches': 'Nisu nađena podudaranja',
	'topbottomRankColumnLabel': 'Dodaj tablici stupac ranga',
	'topbottomNone': 'Ništa',
	'topCount': 'Brojač gornjih',
	'topPercent': 'Gornjih %',
	'bottomCount': 'Brojač donjih',
	'bottomPercent': 'Donjih %',
	'topbottomSearchColumn': 'Pronađi stupac',
	'searchColumnAriaLabel': 'Pronađite stupac. Upišite naziv stupca kojeg tražite, zatim koristite strelicu dolje da pronađete stupac na listi',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Isprazni',

	'rangeFilterControlRegionLabel': 'Filter raspona - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Kontrola s klizačem, koristite strelice desno i lijevo za pomicanje držača klizača',
	'sliderHandleLabel': 'Držač klizača',
	'a11ySliderHandleLabel': 'Držač klizača %{sliderValue}',
	'sliderInputLabel': 'vrijednost',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Neki podaci skupa podataka koji se koriste u ovoj vizualizaciji nisu dostupni.',
	'datasetItemUnavailable': 'Ovaj podatak skupa podataka nije dostupan',

	//Authoring topBottom
	'topOperator': 'Vrh',
	'bottomOperator': 'Dno',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} po %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Samo ovaj objekt',
	'deleteTopBottom': 'Izbriši brojač gornjih ili donjih',
	'editTopBottom': 'Uredi brojač gornjih ili donjih',
	'deleteDrillState': 'Izbriši sadašnje stanje bušenja',
	'ariaDeleteDrillStateLabel': 'Pritisnite tipku ENTER za uređivanje brojača gornjih ili donjih.',
	'drillUpStateTitle': 'Bušenje prema gore',
	'drillDownStateTitle': 'Bušenje prema dolje',
	'ariaEditTopBottomLabel': 'Pritisnite tipku ENTER za uređivanje brojača gornjih ili donjih.',
	'ariaDeleteTopBottomLabel': 'Pritisnite tipku DELETE za brisanje brojača gornjih ili donjih.',

	// Authoring filtering
	'dimFilterIn': 'Uključuje: %{in}',
	'dimFilterNotIn': 'Ne uključuje: %{out}',
	'measureFilterBetween': 'Između %{lowerBound} i %{upperBound}',
	'measureFilterNotBetween': 'Nije između %{lowerBound} i %{upperBound}',
	'gtFilter': 'Poslije %{lowerBound}',
	'ltFilter': 'Prije %{upperBound}',
	'notGtFilter': 'Ne poslije %{lowerBound}',
	'notLtFilter': 'Ne prije %{upperBound}',
	'localFilterTitle': 'Samo ovaj objekt',
	'globalFilterTitle': 'Svi objekti',
	'deleteFilter': 'Izbriši filter',
	'editFilter': 'Uredi filter',
	'ariaEditFilterLabel': 'Pritisnite tipku ENTER za uređivanje filtera.',
	'ariaDeleteFilterLabel': 'Pritisnite tipku DELETE za brisanje filtera.',

	// Prompts
	'ariaEditPrompt': 'Pritisnite tipku ENTER da promijenite prompt vrijednost',

	'moreDataIndicator': 'Vaši podaci su odrezani na %{threshold} stavki. Primijenite filter ako želite prikazati manje.',

	// data point filtering
	'dataPointFilterTitle': 'Točke podataka',
	'dataPointFilterIncludeSummary': 'Uključeno je %{valueCount} točaka podataka',
	'dataPointFilterExcludeSummary': 'Isključeno je %{valueCount} točaka podataka',

	// DB2 connection page
	'db2Database': 'DB2 baza podataka (%{jdbcConnection})',
	'db2Title': 'Povezivanje s IBM DB2',

	// Database
	'databaseConnectionMessage': 'Navedite detalje povezivanja s bazom podataka:',
	'connectionString': 'Niz znakova povezivanja s bazom podataka',
	'databaseCredentials': 'Vjerodajnice: ',
	'databaseUserName': 'Ime korisnika',
	'databasePassword': 'Lozinka',
	'databaseConnect': 'Povezivanje',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Unesite pojam za traženje:',
	'twitterKeyword': 'Ključna riječ',
	'twitterSearch': 'Traži',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Ne možemo kreirati pogled: %{error}\nNeuspješna operacija: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filteri grafičkih elemenata',
	'missingColumn': 'Nedostaje: %{columnLabel}',
	'missingFiltering': 'Nedostaju filteri na sljedećim ID-ovima stupaca:',
	'heatByLabel': 'Toplinski po',
	'evColumns': 'Stupci',
	'evLocalFilters': 'Lokalni filteri',
	'evExpand': 'Proširi',
	'evFilterTooltip': 'Filter',
	'evAdd': 'Dodaj stupac',

	// Navigation View
	'navigationBack': 'Natrag',

	// Pinning
	'contentPinFail': 'Ne možemo skupiti sadržaj. Pokušajte ponovno kasnije.',
	'contentPinFailOld': 'Ne možemo prikvačiti sadržaj. Pokušajte ponovno kasnije.',

	// Layouts
	'dropZoneLabel': 'Ispustite ovdje za maksimiziranje',

	//Share
	'shareDefaultPageTitle': 'Stranica %{index}',

	'nextPage': 'Sljedeća stranica',
	'previousPage': 'Prethodna stranica',

	'assetAssembly': 'pogled',

	'toolbar_save': 'Spremi',
	'brgr_saveAs': 'Spremi kao',
	'brgr_refresh': 'Osvježi',

	// Save
	'saving': 'Spremanje...',
	'save_success': 'Vaš pogled je spremljen.',
	'save_failure': 'Žao nam je. Vaš pogled se nije mogao spremiti. Molim, pokušajte ponovno kasnije.',
	'dashboard_save_success': 'Vaša kontrolna ploča je spremljena.',

	'geminiLeave': 'Napustit ćete IBM Watson Analytics.',

	'warning': 'Upozorenje',
	'missingDataSetData': 'Podaci ovog skupa podataka nisu dostupni. Osvježite skup podataka ili kontaktirajte svog administratora u vezi pristupa izvoru podataka.',

	// Calculations
	'error_calculation_in_use': 'Izabrani izračun se koristi i ne može se izbrisati.',

	'resize': 'Promijeni veličinu',
	'rotate': 'Rotiraj',
	'moveHandle': 'Premjesti widget',
	'expandHandle': 'Proširi',
	'panHandle': 'Prati',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Otiđi do',

	// Slide out titles
	'shapeSlideoutTitle': 'Oblici',
	'textSlideoutTitle': 'Tekst',
	'mediaSlideoutTitle': 'Medij',
	'visualizationSlideoutTitle': 'Vizualizacije',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Navedeni JSON je pogrešan. Pogledajte dnevnik grešaka za više informacija.',

	// Widget type labels
	'shape_label': 'Oblik',
	'image_label': 'Slika',
	'data_label': 'Grafikon',
	'media_label': 'Medij',
	'text_label': 'Tekst',
	'embedMedia_label': 'Medij',
	'youtube_label': 'YouTube video',
	'webpage_label': 'Web stranica',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Oblik',
	'noExtraText_shape_numbered': 'Oblik (%{number})',
	'few_shape': 'Grupa od %{count} oblika',
	'many_shape': 'Grupa od %{count} oblika',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} slika',
	'one_image_numbered': '%{text} slika (%{number})',
	'noExtraText_image': 'Slika',
	'noExtraText_image_numbered': 'Slika (%{number})',
	'few_image': 'Grupa od %{count} slika',
	'many_image': 'Grupa od %{count} slika',
	'noExtraText_text': 'Isprazni okvir za tekst',
	'noExtraText_text_numbered': 'Prazni tekst okvir (%{number})',
	'few_text': 'Grupa od %{count} tekst okvira',
	'many_text': 'Grupa od %{count} tekst okvira',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Crosstab %{values} po %{row_level1} i %{column_level1}',
	'crosstab_opt_mapping_numbered': 'Crosstab (%{number}) %{values} po %{row_level1} i %{column_level1}',
	'crosstab_has_mapping': 'Crosstab %{values} po %{row_level1}',
	'crosstab_has_mapping_numbered': 'Crosstab %{values} po %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Prazan crosstab',
	'crosstab_no_mapping_numbered': 'Prazan crosstab (%{number})',
	'crosstab_named': '%{name} crosstab',
	'crosstab_named_numbered': '%{name} crosstab (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': 'Tablica %{grid_cols}',
	'JQGrid_has_mapping_numbered': 'Tablica (%{number}) %{grid_cols}',
	'JQGrid_no_mapping': 'Prazna tablica',
	'JQGrid_no_mapping_numbered': 'Prazna tablica (%{number})',
	'JQGrid_named': 'Tablica %{name}',
	'JQGrid_named_numbered': 'Tablica (%{number}) %{name}',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} hijerarhija',
	'hierarchy_has_mapping_numbered': '%{level1} hijerarhija (%{number})',
	'hierarchy_no_mapping': 'Prazna hijerarhija',
	'hierarchy_no_mapping_numbered': 'Prazna hijerarhija (%{number})',
	'hierarchy_named': '%{name} hijerarhija',
	'hierarchy_named_numbered': '%{name} hijerarhija (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} mapa',
	'map_has_mapping_numbered': '%{categories} mapa (%{number})',
	'map_no_mapping': 'Prazna mapa',
	'map_no_mapping_numbered': 'Prazna mapa (%{number})',
	'map_named': '%{name} mapa',
	'map_named_numbered': '%{name} mapa (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} sumarna vrijednost',
	'summary_has_mapping_numbered': '%{actual} sumarna vrijednost (%{number})',
	'summary_no_mapping': 'Prazno sumiranje',
	'summary_no_mapping_numbered': 'Prazna sumarna vrijednost (%{number})',
	'summary_named': '%{name} sumiranje',
	'summary_named_numbered': '%{name} sumarna vrijednost (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} po %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} po %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'Prazan KPI',
	'kpi_no_mapping_numbered': 'Prazan KPI (%{number})',
	'kpi_named': 'KPI %{name}',
	'kpi_named_numbered': 'KPI %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infografika',
	'infographicSummary_has_mapping_numbered': '%{actual} infografika (%{number})',
	'infographicSummary_no_mapping': 'Prazna infografika',
	'infographicSummary_no_mapping_numbered': 'Prazna infografika (%{number})',
	'infographicSummary_named': 'Infografika %{name}',
	'infographicSummary_named_numbered': 'Infografika %{name} (%{number})',
	'noExtraText_youtube': 'YouTube video',
	'noExtraText_youtube_numbered': 'YouTube video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube video',
	'one_youtube_numbered': '%{text} YouTube video (%{number})',
	'few_youtube': 'Grupa od %{count} YouTube videa',
	'many_youtube': 'Grupa od %{count} YouTube videa',
	'noExtraText_embedMedia': 'Poveznica medija',
	'noExtraText_embedMedia_numbered': 'Poveznica medija (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} poveznica medija',
	'one_embedMedia_numbered': '%{text} poveznica medija (%{number})',
	'few_embedMedia': 'Grupa od %{count} poveznica medija',
	'many_embedMedia': 'Grupa od %{count} poveznica medija',
	'noExtraText_media': 'Medij',
	'noExtraText_media_numbered': 'Medij (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} medij',
	'one_media_numbered': '%{text} medij (%{number})',
	'few_media': 'Grupa od %{count} medija',
	'many_media': 'Grupa od %{count} medija',
	'noExtraText_webpage': 'Web stranica',
	'noExtraText_webpage_numbered': 'Web stranica (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} web stranica',
	'one_webpage_numbered': '%{text} web stranica (%{number})',
	'few_webpage': 'Grupa od %{count} web stranica',
	'many_webpage': 'Grupa od %{count} web stranica',
	'one_unknown': 'Objekt',
	'one_unknown_numbered': 'Objekt (%{number})',
	'few_unknown': 'Grupa od %{count} objekata',
	'many_unknown': 'Grupa od %{count} objekata',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Sljedeće',
	'previous': 'Prethodno',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Trenutna navigacijska grupa je %{navigation_group_name}',

	//Page Context
	'filterBlank': '(prazno)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Vrijednosti filtera se ne mogu učitati',
	'editTimelineHighlight': 'Uredi isticanje',

	'filterDockChevronLeft': 'Pomiči se kroz podatke',
	'filterDockChevronRight': 'Pomiči se kroz podatke',
	'expand': 'Proširi',
	'collapse': 'Skupi',

	//Reset Dashboard
	'dashboardResetTitle': 'Resetiraj kontrolnu ploču',
	'dashboardResetMessage': 'Jeste li sigurni da želite resetirati sve promjene napravljene na ovoj kontrolnoj ploči?',
	'dashboardResetToast': 'Vaša kontrolna ploča je resetirana.',

	//Generate PDF
	'buildingPDF': 'Izgradnja PDF-a...',
	'exportPDF': 'Eksport u PDF',
	'pageSize': 'Veličina stranice',
	'orientation': 'Orijentacija',
	'filtersPresentPDF': 'Filter(i) primijenjeni na vizualizaciju(e) na prethodnoj stanici:',
	'errorPDF': 'Ne može se generirati PDF. Molim osvježite i pokušajte ponovno.',
	'printPDFInfo': 'Pregled dokumentacije',
	'pdfWidget': 'Grafički element',
	'includeFilters': 'Pokaži detalje filtera',
	'portrait': 'Portret',
	'landscape': 'Položeno',
	'letter': 'Pismo',
	'legal': 'Pravno',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Vaša kontrolna ploča je nadograđena. Spremite sad da zadržite optimalne performanse.',

	'ariaFullScreenMessage': 'Pritisnite Escape da izađete iz prikaza na cijelom ekranu',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} pakirani hijerarhijski mjehuričasti grafikon',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} pakirani hijerarhijski mjehuričasti grafikon (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Prazan pakirani hijerarhijski mjehuričasti grafikon',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Prazan pakirani hijerarhijski mjehuričasti grafikon (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} pakirani hijerarhijski mjehuričasti grafikon',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} pakirani hijerarhijski mjehuričasti grafikon (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} po %{values} marimekko grafikon',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} po %{values} marimekko grafikon(%{number})',
	'LIVE_marimekko_no_mapping': 'Prazan marimekko grafikon',
	'LIVE_marimekko_no_mapping_numbered': 'Prazan marimekko grafikon (%{number})',
	'LIVE_marimekko_named': '%{name} marimekko grafikon',
	'LIVE_marimekko_numbered': '%{name} marimekko grafikon (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} sunburst grafikon',
	'LIVE_sunburst_has_mapping_numbered': '%{values} sunburst grafikon (%{number})',
	'LIVE_sunburst_no_mapping': 'Prazan sunburst grafikon',
	'LIVE_sunburst_no_mapping_numbered': 'Prazan sunburst grafikon (%{number})',
	'LIVE_sunburst_named': '%{name} sunburst grafikon',
	'LIVE_sunburst_named_numbered': '%{name} sunburst grafikon (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Grafikon analize pogonitelja %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Grafikon analize pogonitelja %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Prazan grafikon analize pogonitelja',
	'LIVE_decision_analysis_no_mapping_numbered': 'Prazan grafikon analize pogonitelja (%{number})',
	'LIVE_decision_analysis_named': 'Grafikon analize pogonitelja %{name}',
	'LIVE_decision_analysis_named_numbered': 'Grafikon analize pogonitelja %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} po %{columnValue} i %{lineValue} linijski i stupčasti grafikon',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} po %{columnValue} i %{lineValue} linija i stupčasti grafikon (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} i %{lineValue} linija i stupčasti grafikon',
	'LIVE_line_column_has_mapping_numbered': '%{categories} po %{columnValue} i %{lineValue} linija i stupčasti grafikon (%{number})',
	'LIVE_line_column_no_mapping': 'Prazan linijski i stupčasti grafikon',
	'LIVE_line_column_no_mapping_numbered': 'Prazan linijski i stupčasti grafikon (%{number})',
	'LIVE_line_column_named': '%{name} linijski i stupčasti grafikon',
	'LIVE_line_column_named_numbered' : '%{name} linijski i stupčasti grafikon (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} puta %{y} i %{size} mjehuričasti grafikon',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} puta %{y} i %{size} mjehuričasti grafikon (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Prazan mjehuričasti grafikon',
	'LIVE_bubble_chart_no_mapping_numbered': 'Prazan mjehuričasti grafikon (%{number})',
	'LIVE_bubble_chart_named': '%{name} mjehuričasti grafikon',
	'LIVE_bubble_chart_named_numbered': '%{name} mjehuričasti grafikon (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} bullet grafikon',
	'LIVE_bullet_has_mapping_numbered': '%{actual} bullet grafikon (%{number})',
	'LIVE_bullet_no_mapping': 'Prazan bullet grafikon',
	'LIVE_bullet_no_mapping_numbered': 'Prazan bullet grafikon (%{number})',
	'LIVE_bullet_named': '%{name} bullet grafikon',
	'LIVE_bullet_named_numbered': '%{name} bullet grafikon (%{number})'
});
